import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Modules from '../../components/modules'
import withModules from '../../containers/with-modules'
import pagesHoc from '../pages-hoc'
import pageLoadDataLayer, {
  mapTemplateToPageLoadData,
} from '../../helpers/analytics-utils/page-load-data-layer'
import { useEvolvedContext } from '../../context'
import styles from './index.module.scss'

const Template = ({ template, modules, centre }) => {
  const isEvolved = useEvolvedContext()

  useEffect(() => {
    pageLoadDataLayer(mapTemplateToPageLoadData(template), centre)
  }, [centre, template])

  if (modules == null) {
    return <pre>Loading...</pre>
  }

  return (
    <div className={classNames({ [styles.evolved]: isEvolved })}>
      <Modules
        initialAngle="top-right"
        className={styles.initialContentGroup}
        modules={modules || []}
      />
    </div>
  )
}

Template.propTypes = {
  modules: PropTypes.array,
  template: PropTypes.object,
  centre: PropTypes.object,
}

const getMetaData = ({ centre, template }) => ({
  title: `${template.title} at Westfield ${centre.title}`,
  description: `Westfield ${centre.title} - home to your favourite ${template.title} selection. Explore our range of ${template.title} brands, events & offers at Westfield ${centre.title}.`,
})

export default withModules(pagesHoc(Template, getMetaData))
